const initialState = {
  emailStatus: null, // 'success', 'failure', oder null
  emailError: null,
};

const mailReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SEND_EMAIL_SUCCESS":
      return {
        ...state,
        emailStatus: "success",
        emailError: null,
      };
    case "SEND_EMAIL_FAILURE":
      return {
        ...state,
        emailStatus: "failure",
        emailError: action.payload || null,
      };
    default:
      return state;
  }
};

export default mailReducer;
